import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { themeAtom } from '@frontend/atoms/appearanceAtom';

export function useTheme() {
  const theme = useAtomValue(themeAtom);

  useEffect(() => {
    const root = document.documentElement;

    root.style.colorScheme = theme;
  }, [theme]);
}
